// extracted by mini-css-extract-plugin
export default {"Package":"PageLink_Package__+8VMN","PageLink":"PageLink_PageLink__hfYX+"};